import "./App.css";
import "./styles/hussar.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import MainApp from "./pages/MainApp";
import CommandMode from "./pages/CommandMode";
import Settings from "./pages/Settings";
import Subscription from "./pages/Subscription";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Analytics from "./pages/Analytics";
import AdminUsers from "./pages/AdminUsers";
import Conversations from "./pages/Conversations";
import Honor from "./pages/Honor";
import Responsibility from "./pages/Responsibility";
import CoNowego from "./pages/CoNowego";
import PressKit from "./pages/PressKit";
import ComplianceOperator from "./pages/ComplianceOperator";
import DlaAdministracji from "./pages/DlaAdministracji";
import BezpieczenstwoIZgodnosc from "./pages/BezpieczenstwoIZgodnosc";
import PilotPubliczny from "./pages/PilotPubliczny";
import TrainingCenter from "./pages/TrainingCenter";
import CompanyBrain from "./pages/CompanyBrain";
import ProcessPatterns from "./pages/ProcessPatterns";
import DataGovernance from "./pages/DataGovernance";
import ImmigrationIntel from "./pages/ImmigrationIntel";
import AIActPolska from "./pages/AIActPolska";
import SposobyWspolpracy from "./pages/SposobyWspolpracy";
import SecurityEvents from "./pages/SecurityEvents";
import AuthenticityShield from "./pages/AuthenticityShield";
import TarczaAutentycznosci from "./pages/TarczaAutentycznosci";
import ProtokolAi from "./pages/ProtokolAi";
import ImmigrationIntelligencePublic from "./pages/ImmigrationIntelligencePublic";
import CaseHubPublic from "./pages/CaseHubPublic";
import ImmigrationCaseDashboard from "./pages/ImmigrationCaseDashboard";
import MojeAktaImigracyjne from "./pages/MojeAktaImigracyjne";
import WiedzaAiWAktachImigracyjnych from "./pages/WiedzaAiWAktachImigracyjnych";
import WiedzaJakUporzadkowacAktaImigracyjne from "./pages/WiedzaJakUporzadkowacAktaImigracyjne";
import WiedzaObserwacjaAiSlad from "./pages/WiedzaObserwacjaAiSlad";
import WiedzaHussaraiNieDecyduje from "./pages/WiedzaHussaraiNieDecyduje";
import WiedzaFounderManifest from "./pages/WiedzaFounderManifest";
import WiedzaWEuropieAiPrzejrzyste from "./pages/WiedzaWEuropieAiPrzejrzyste";
import WiedzaIndex from "./pages/WiedzaIndex";
import DlaInstytucji from "./pages/DlaInstytucji";
import DlaProfesjonalistow from "./pages/DlaProfesjonalistow";
import ReviewAktImigracyjnych from "./pages/ReviewAktImigracyjnych";
import GoneRoute from "./pages/GoneRoute";
import MosPreCheck from "./pages/MosPreCheck";
import KonradKwiatkowski from "./pages/KonradKwiatkowski";
import SplashScreen from "./components/SplashScreen";
import PageviewTracker from "./components/PageviewTracker";

/**
 * Malformed-login URL SEO scrub (2026-02-19).
 *
 * The URL `https://hussarai.org/%20login` (encoded-space prefix before
 * "login") appeared in external / AI-search contexts. It corresponds to
 * no HussarAi page. We intercept any path of the shape
 *     /(one or more encoded/literal whitespace chars)login(optional /)
 * and render <GoneRoute variant="malformed-login"> so:
 *   - the SPA emits <meta name="robots" content="noindex, nofollow">
 *   - a 410 Gone hint is set
 *   - a polite pointer to the real /login route is shown
 *
 * The real /login route is unaffected and continues to render <Login />.
 * Regex is case-insensitive and matches both the encoded (%20) and
 * decoded (whitespace) forms the browser might expose in pathname.
 */
const MALFORMED_LOGIN_RE = /^\/(?:%20|\s)+login\/?$/i;

const AppRoutes = () => {
  const location = useLocation();
  if (MALFORMED_LOGIN_RE.test(location.pathname)) {
    return <GoneRoute variant="malformed-login" />;
  }
  return (
    <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/honor" element={<Honor />} />
            <Route path="/odpowiedzialnosc" element={<Responsibility />} />
            <Route path="/responsibility" element={<Responsibility />} />
            <Route path="/co-nowego" element={<CoNowego />} />
            <Route path="/changelog" element={<CoNowego />} />
            <Route path="/press-kit" element={<PressKit />} />
            <Route path="/operator-zgodnosci" element={<ComplianceOperator />} />
            <Route path="/compliance-operator" element={<ComplianceOperator />} />
            <Route path="/dla-administracji" element={<DlaAdministracji />} />
            <Route path="/bezpieczenstwo-i-zgodnosc" element={<BezpieczenstwoIZgodnosc />} />
            <Route path="/pilot-publiczny" element={<PilotPubliczny />} />
            <Route path="/admin/training-center" element={<AdminRoute><TrainingCenter /></AdminRoute>} />
            <Route path="/admin/company-brain" element={<AdminRoute><CompanyBrain /></AdminRoute>} />
            <Route path="/admin/process-patterns" element={<AdminRoute><ProcessPatterns /></AdminRoute>} />
            <Route path="/admin/data-governance" element={<AdminRoute><DataGovernance /></AdminRoute>} />
            <Route path="/admin/immigration-intel" element={<AdminRoute><ImmigrationIntel /></AdminRoute>} />
            <Route path="/admin/security-events" element={<AdminRoute><SecurityEvents /></AdminRoute>} />
            <Route path="/admin/authenticity-shield" element={<AdminRoute><AuthenticityShield /></AdminRoute>} />
            <Route path="/ai-act-polska" element={<AIActPolska />} />
            <Route path="/sposoby-wspolpracy" element={<SposobyWspolpracy />} />
            <Route path="/ways-to-work" element={<SposobyWspolpracy />} />
            <Route path="/tarcza-autentycznosci" element={<TarczaAutentycznosci />} />
            <Route path="/authenticity-shield" element={<TarczaAutentycznosci />} />
            <Route path="/protokol-ai" element={<ProtokolAi />} />
            <Route path="/ai-protocol" element={<ProtokolAi />} />
            <Route path="/imigracja-i-urzedy" element={<ImmigrationIntelligencePublic />} />
            <Route path="/immigration-intelligence" element={<ImmigrationIntelligencePublic />} />
            <Route path="/dashboard-akt-imigracyjnych" element={<CaseHubPublic />} />
            <Route path="/immigration-case-dashboard" element={<CaseHubPublic />} />
            <Route path="/moje-akta-imigracyjne" element={<MojeAktaImigracyjne />} />
            <Route path="/my-immigration-record" element={<MojeAktaImigracyjne />} />
            <Route path="/wiedza" element={<WiedzaIndex />} />
            <Route path="/knowledge" element={<WiedzaIndex />} />
            <Route path="/dla-instytucji" element={<DlaInstytucji />} />
            <Route path="/for-institutions" element={<DlaInstytucji />} />
            <Route path="/dla-profesjonalistow" element={<DlaProfesjonalistow />} />
            <Route path="/for-professionals" element={<DlaProfesjonalistow />} />
            <Route path="/review-akt-imigracyjnych" element={<ReviewAktImigracyjnych />} />
            <Route path="/immigration-record-review" element={<ReviewAktImigracyjnych />} />
            <Route path="/wiedza/ai-w-aktach-imigracyjnych" element={<WiedzaAiWAktachImigracyjnych />} />
            <Route path="/knowledge/ai-in-immigration-records" element={<WiedzaAiWAktachImigracyjnych />} />
            <Route path="/wiedza/jak-uporzadkowac-akta-imigracyjne" element={<WiedzaJakUporzadkowacAktaImigracyjne />} />
            <Route path="/knowledge/how-to-organize-immigration-records" element={<WiedzaJakUporzadkowacAktaImigracyjne />} />
            <Route path="/wiedza/kazda-obserwacja-ai-slad-zrodlowy" element={<WiedzaObserwacjaAiSlad />} />
            <Route path="/knowledge/every-ai-observation-should-have-a-receipt" element={<WiedzaObserwacjaAiSlad />} />
            <Route path="/wiedza/dlaczego-hussarai-nie-pozwala-ai-decydowac" element={<WiedzaHussaraiNieDecyduje />} />
            <Route path="/knowledge/why-hussarai-does-not-let-ai-make-immigration-decisions" element={<WiedzaHussaraiNieDecyduje />} />
            <Route path="/wiedza/w-europie-ai-musi-byc-przejrzyste" element={<WiedzaWEuropieAiPrzejrzyste />} />
            <Route path="/knowledge/in-europe-ai-must-explain-itself" element={<WiedzaWEuropieAiPrzejrzyste /> } />
            <Route path="/wiedza/dlaczego-zbudowalem-hussarai" element={<WiedzaFounderManifest />} />
            <Route path="/knowledge/why-i-built-hussarai" element={<WiedzaFounderManifest />} />
            <Route path="/admin/immigration-case" element={<AdminRoute><ImmigrationCaseDashboard /></AdminRoute>} />

            {/* MOS PreCheck — Weryfikacja przed MOS (Prompt 2 MVP, temp_residence only) */}
            <Route path="/mos/precheck" element={<ProtectedRoute><MosPreCheck /></ProtectedRoute>} />
            <Route path="/mos-precheck" element={<ProtectedRoute><MosPreCheck /></ProtectedRoute>} />
            <Route path="/weryfikacja-przed-mos" element={<ProtectedRoute><MosPreCheck /></ProtectedRoute>} />

            {/* Canonical founder / entity page */}
            <Route path="/konrad-kwiatkowski" element={<KonradKwiatkowski />} />

            {/* -----------------------------------------------------------------
                LeadWing separation (2026-02-10)

                HussarAi is European immigration-record-integrity infrastructure.
                LeadWing is a separate commercial AI lead/intake product and has
                been extracted to /app/leadwing_extracted/.

                Every URL below was previously a LeadWing-branded page,
                Lead-Operator hub, or commercial SaaS surface on HussarAi.
                They are now permanently retired from HussarAi and render a
                client-side 410 Gone notice (noindex, no marketing, no redirect
                back into HussarAi doctrine copy).

                Do not resurrect these routes under HussarAi. If LeadWing needs
                a public home again, it belongs on its own Emergent project /
                domain.
                ----------------------------------------------------------------- */}
            <Route path="/pricing" element={<GoneRoute />} />
            <Route path="/leadwing" element={<GoneRoute />} />
            <Route path="/leadwing-pl" element={<GoneRoute />} />
            <Route path="/hvac-wroclaw" element={<GoneRoute />} />
            <Route path="/polski-operator-leadow-ai" element={<GoneRoute />} />
            <Route path="/eksport" element={<GoneRoute />} />
            <Route path="/export" element={<GoneRoute />} />
            <Route path="/lead-magnet" element={<GoneRoute />} />
            <Route path="/agenci-ai-dla-msp" element={<GoneRoute />} />
            <Route path="/vs/bielik" element={<GoneRoute />} />
            <Route path="/operator" element={<GoneRoute />} />
            <Route path="/operator/leads" element={<GoneRoute />} />

            {/* Protected Routes */}
            <Route path="/app" element={<ProtectedRoute><MainApp /></ProtectedRoute>} />
            <Route path="/command" element={<ProtectedRoute><CommandMode /></ProtectedRoute>} />
            <Route path="/conversations" element={<ProtectedRoute><Conversations /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/subscription" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />
            <Route path="/analytics" element={<AdminRoute><Analytics /></AdminRoute>} />
            <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
            <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
            <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
          </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <SplashScreen>
        <AuthProvider>
          <BrowserRouter>
            <PageviewTracker />
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </SplashScreen>
    </div>
  );
}

export default App;
